<template>
    <!-- 互助服务 -->
    <div>
        <div class="container">
            <div class="handle-box">
                <el-form :inline="true" ref="form" :model="query" label-width="100px">
                    <el-form-item label="评分状态：">
                        <el-select v-model="query.ratingStatus" clearable placeholder="请选择完成状态">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="未完成" value="未完成"></el-option>
                            <el-option label="已完成" value="已完成"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-button type="primary" icon="el-icon-search" class="ml20" @click="getData">查询</el-button>
                    <!-- <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新建</el-button> -->
                </el-form>
            </div>
            <el-table :data="tableData" border class="table">
                <el-table-column prop="name" label="姓名"></el-table-column>
                <el-table-column prop="mobile" label="联系电话"></el-table-column>
                <!-- <el-table-column prop="type" :formatter="formatType" label="申请方式"></el-table-column> -->
                <el-table-column prop="address" label="居住地址"></el-table-column>
                <el-table-column prop="goods" label="服务内容"></el-table-column>
                <el-table-column prop="price" label="服务金额"></el-table-column>
                <el-table-column prop="status" :formatter="formatStatus" label="审核状态"></el-table-column>
                <el-table-column prop="createdTime" label="评价时间" :formatter="formatCreatedTime"></el-table-column>
                <el-table-column label="评分" width="150" align="center">
                    <template slot-scope="scope">
                        <el-rate v-if="scope.row.evaluate" :value="scope.row.evaluate" disabled></el-rate>
                        <el-rate v-else :value="0" disabled></el-rate>
                    </template>
                </el-table-column>
                <el-table-column label="评分状态" width="150" align="center">
                    <template slot-scope="scope">
                        {{ formatRatingStatus(scope.row) }}
                    </template>
                </el-table-column>
                <!-- <template slot-scope="scope"> -->
                <!-- <i :class="scope.row.isLogin==1?'el-icon-circle-check':'el-icon-circle-close'"/> -->
                <!-- </template> -->
            </el-table>
            <div class="pagination">
                <el-pagination background layout="total, prev, pager, next" :current-page="query.pageNum"
                    :page-size="query.pageSize" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'huzhuNeed',
    data() {
        return {
            query: {
                name: "",
                status: "",
                groupName: "",
                id: ""
            },
            tableData: [],
            editVisible: false,
            psdVisible: false,
            isAdd: true,
            pageTotal: 0,
            myHeaders: { Authorization: localStorage.getItem('token') },

            psdform: {},

            form: {},

        };
    },
    created() {
        this.getData();
    },
    methods: {
        formatStatue(row, index) {
            if (row.openStatus == 0) {
                return '正常营业';
            } else {
                return '暂停营业';
            }
        },
        formatStatus(row, index) {
            if (row.status == 0) {
                return '待审核';
            } if (row.status == 2) {
                return '审核通过';
            } if (row.status == 4) {
                return '审核不通过';
            } else {
                return null;
            }
        },
        formatType(row, index) {
            if (row.type == 0) {
                return '入院咨询';
            } if (row.type == 1) {
                return '预约参观';
            } else {
                return null;
            }
        },
        formatRating(row, index) {
            if (row.starRating == 1) {
                return '一星';
            } if (row.starRating == 2) {
                return '二星';
            } if (row.starRating == 3) {
                return '三星';
            } if (row.starRating == 4) {
                return '四星';
            } if (row.starRating == 5) {
                return '五星';
            } else {
                return null;
            }

        },
        formatRatingStatus(row) {
            return row.evaluate ? '已完成' : '未完成';
        },
        formatRating(row) {
            if (!row.evaluate) {
                return '';
            } else {
                let stars = '';
                for (let i = 0; i < row.evaluate; i++) {
                    stars += '★';
                }
                return stars;
            }
        },
        formatCreatedTime(row, index) {
            if (row.createdTime) {
                const date = new Date(row.createdTime);
                return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
            } else {
                return null;
            }
        },
        getData() {
            this.$postJson('omc/WxApiPreService/show', { groupId: 1101 }).then(res => {
                console.log(res);
                if (res.result && res.result.list) {
                    this.tableData = res.result.list;
                    this.pageTotal = Number(res.result.total)
                } else {
                    // 处理搜索失败的情况，可以显示错误信息或清空表格数据等
                    this.tableData = [];
                    this.pageTotal = 0;
                }
            })
        },


        // 触发添加按钮
        handleAdd() {
            this.form = {
                name: '',
                phone: '',
                type: '',
                status: '',
                community: '',
                street: '',
                groupName: '',
                address: '',
                content: '',
                creator: '',
                createdTime: ''
            };
            this.editVisible = true;
            this.isAdd = true;
            this.sendRequest();
        },
        // 删除操作
        // handleDelete(index, row) {
        //     // 二次确认删除
        //     this.$confirm('确定要删除吗？', '提示', {
        //         type: 'warning'
        //     }).then(() => {
        //         // hgz/post/deleteById
        //         this.$postJson(`uac/group/getDb/{groupId}/${row.id}`)
        //             .then(res => {
        //                 if (res.status) {
        //                     this.$message({
        //                         type: 'success',
        //                         message: '删除成功!'
        //                     });
        //                     setTimeout(() => {
        //                         this.getData();
        //                     }, 1000)
        //                 } else {
        //                     this.$message({
        //                         type: 'error',
        //                         message: res.message
        //                     });
        //                 }
        //             })

        //     }).catch(() => {

        //     });
        // },
        handlePsd(index, row) {
            this.psdform = {
                loginName: row.loginName,
                groupId: row.groupId,
                password: '',
                confirmPwd: ''
            }
            this.psdVisible = true;
        },
        savePsdForm() {
            //slm/user/modifyPwd
            this.$postJson('uac/group/editDb', this.psdform).then(res => {
                if (res.status) {
                    this.$message({
                        type: 'success',
                        message: '操作成功'
                    });
                    this.psdVisible = false;
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    });
                }
            })
        },
        // 编辑操作
        // handleEdit(index, row) {
        //     this.form = Object.assign(row,{});
        //     this.editVisible = true;
        //     this.isAdd = false;
        //     this.sendRequest();
        // },
        agree(row) {
            // 更新本地数据中的审核状态为审核通过（2）
            row.status = 2;
            console.log(row.id);
            let id = row.id;
            this.$postForm("uac/staff/agree/" + id).then((res) => {
                console.log(res);
                if (res.code == 200) {
                    this.$message({
                        type: "success",
                        message: res.message,
                    });
                } else {
                    this.$message({
                        type: "error",
                        message: res.message,
                    });
                }
                this.getTableData();
                this.$refs.alarmlogTable.clearSelection(); //清空表格checkbox选择的值  by guo 2019-11-20-16:00 添加
            });
        },
        disAgree(row) {
            // 更新本地数据中的审核状态为审核不通过（4）
            row.status = 4;
            console.log(row.id);
            let id = row.id;
            this.$postForm("uac/staff/disAgree/" + id).then((res) => {
                console.log(res);
                if (res.code == 200) {
                    this.$message({
                        type: "success",
                        message: res.message,
                    });
                } else {
                    this.$message({
                        type: "error",
                        message: res.message,
                    });
                }
                this.getTableData();
                this.$refs.alarmlogTable.clearSelection(); //清空表格checkbox选择的值  by guo 2019-11-20-16:00 添加
            });
        },
        //回访操作
        returnVisit() {

        }, returnVisit(row) {
            this.$confirm('是否已回访？', '请确认回访状态', {
                confirmButtonText: '是',
                cancelButtonText: '否',
            })
                .then(() => {
                    // 用户选择“是”，发送已回访状态
                    this.$postJson(`uac/groupReservation/confirm/${row.id}`, { status: '已回访' })
                        .then(response => {
                            console.log('已回访成功', response);
                        })
                        .catch(error => {
                            console.error('已回访失败', error);
                        });
                })
                .catch(() => {
                    // 用户选择“否”，发送未回访状态
                    this.$postJson(`uac/groupReservation/confirm/${row.id}`, { status: '未回访' })
                        .then(response => {
                            console.log('未回访成功', response);
                        })
                        .catch(error => {
                            console.error('未回访失败', error);
                        });
                });
        },
        sendRequest() {
            let url = '';
            let params = {};
            if (!this.isAdd) {
                url = 'uac/group/updateDbData';
                params = { ...this.formData, id: this.editId }
            } else {
                url = 'uac/group/addDbData';
                params = this.getData
            }
        },

        // 保存编辑
        saveEdit() {
            let url = '';
            // let params = {};
            if (!this.isAdd) {
                url = 'uac/group/updateDbData';
                // params = { ...this.formData, id: this.editId }
            } else {
                url = 'uac/group/addDbData';
                // params = this.getData
            }
            console.log(this.form);
            this.$postJson(url, this.form).then(res => {
                console.log(res);
                if (res.code == 200) {
                    this.$message({
                        type: 'success',
                        message: '操作成功'
                    });
                    this.editVisible = false;
                    this.getData();
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    });
                }
            })
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
            this.getData();
        },
        handleAvatarSuccess(res, file) {
            console.log(res);
            this.form.avatar = res.data[0].resourcePath;
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 5;
            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 5MB!');
            }
            return isJPG && isLt2M;
        }
    }
};

</script>

<style scoped>
.handle-box {
    margin-bottom: 5px;
}

.handle-input {
    width: 200px;
}

.common-select {
    width: 285px;
}

.common-input {
    width: 285px;
}

.big-input {
    width: 675px;
}

.sex-select {
    width: 90px;
}

.table {
    width: 100%;
    font-size: 14px;
}

.ml20 {
    margin-left: 20px;
}

.avatar-uploader {
    width: 180px;
}

.big_iv>>>.el-upload {
    width: 180px;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.el-upload--text {
    width: 180px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
</style>